import React from 'react';
import '../styles/components/AboutUs.css';
import aboutImg from '../assets/tagline.jpg.png'; // ✅ Replace with your image path

const AboutUs = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-text">
          <p className="about-subtitle">ABOUT US</p>
          <h2 className="about-title">Driven by Precision, Defined by Perfection, Powered by Pride</h2>
          <p className="about-description">
           Jai Vishwakarma Enterprises has been building trust since 2001, delivering strength, style, and reliability in every project. We specialize in residential, commercial, and industrial construction, as well as renovations, interiors, and exteriors. With precision craftsmanship and innovative design, we create spaces that inspire and endure. For us, every project is more than just construction – it’s your trust, built to last.
          </p>
          <a href= '#team' className="about-button">MEET OUR TEAM</a>
        </div>

        <div className="about-image">
          <img src={aboutImg} alt="About us" />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
